// extracted by mini-css-extract-plugin
export var addWidgetButton = "_11-6";
export var backButton = "_11-1";
export var legacyWidgetContainer = "_11-5";
export var pageContainer = "_11-2";
export var settingsContent = "_11-0";
export var widgetSubsectionItem = "_11-3";
export var widgetSubsectionItemContent = "_11-4";